export const logoutUser = () => {
  window.localStorage.clear();
  window.sessionStorage.clear();
  window.location.href = '/';
};